import queryString from 'query-string'
import apiV2 from '.'

export const filesV2Api = apiV2.injectEndpoints({
  endpoints: builder => ({
    getFileTags: builder.query({
      query: ({ eventId }) => `/files/v2/tags?${queryString.stringify({ eventId })}`,
      transformResponse: response => response.data.tags,
      providesTags: ['FILE_TAGS'],
    }),
    getFileBreadcrumbs: builder.query({
      query: ({ eventId, domainId, all, search, tagIds, types }) =>
        `/files/v2/breadcrumbs?${queryString.stringify({ eventId, domainId, all, search, tagIds, types })}`,
      transformResponse: response => response.data,
      providesTags: ['FILE_BREADCRUMBS'],
    }),
    getFilesV2: builder.query({
      query: ({ domainId, eventId, breadcrumbId, offset, limit, search, tagIds, types }) =>
        `/files/v2/me?${queryString.stringify({ domainId, eventId, breadcrumbId, offset, limit, search, tagIds, types })}`,
      transformResponse: response => response.data,
      providesTags: ['FILES_V2'],
    }),
  }),
})

export const { useGetFileBreadcrumbsQuery, useLazyGetFilesV2Query, useGetFileTagsQuery } = filesV2Api
